import { InfoTip } from '@shared-ui/components';
import type { SiteAnalytics as Data } from '../../../api/siteAnalyticsApi';
import PathSunburst from '../shared/PathSunburst';

export function PathsView({ data }: { data: Data }) {
  if (data.paths.children.length === 0) {
    return <section className="sa-panel"><p className="sa-empty">No pages read in this window.</p></section>;
  }
  return (
    <section className="sa-panel">
      <h2>
        Where the reading went
        <InfoTip>
          <span className="sa-tip-p">
            Every page view, split on the URL. Slices are sized by <strong>page views</strong>, not sessions:
            a section is the sum of its pages, and one session reading two chemistry pages would be counted
            twice if sessions were summed.
          </span>
        </InfoTip>
      </h2>
      <PathSunburst root={data.paths} />
    </section>
  );
}
